import { API, unwrapData } from '../axios-instance'
import {
  AwardRefinement,
  CreateAwardRefinementParams,
  CreateRecognitionRefinementParams,
  RecognitionRefinement,
} from './types'

export const createRecognitionRefinement = async (params: CreateRecognitionRefinementParams) => {
  return await API.post<RecognitionRefinement>('/refinement/refinements/recognition', params).then(
    unwrapData,
  )
}

export const createAwardRefinement = async (params: CreateAwardRefinementParams) => {
  return await API.post<AwardRefinement>('/refinement/refinements/award', params).then(unwrapData)
}

export const deleteRefinement = async (refinementId: string) => {
  return await API.delete<boolean>(`/refinement/refinements/${refinementId}`)
}
